(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/change-password/change-password.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/change-password/change-password.js');
"use strict";


const LOGIN = svs.ticket_partner.constants.routes.LOGIN;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const _svs$ticket_partner$c = svs.ticket_partner.changePassword.constants.FORMS,
  HEADER = _svs$ticket_partner$c.HEADER,
  INFO_ONE_TIME_PASSWORD = _svs$ticket_partner$c.INFO_ONE_TIME_PASSWORD;
const _React = React,
  useEffect = _React.useEffect;
const PageWrapper = svs.ticket_partner.sharedComponents.pageWrapper.PageWrapper;
const ChangePassword = () => {
  const ChangePasswordForm = svs.ticket_partner.changePassword.ChangePasswordForm;
  const _svs$ticket_partner$u = svs.ticket_partner.useUserContext(),
    hasRetailerCorpRole = _svs$ticket_partner$u.hasRetailerCorpRole,
    hasOneTimePassword = _svs$ticket_partner$u.hasOneTimePassword,
    setOneTimePasswordUpdated = _svs$ticket_partner$u.setOneTimePasswordUpdated;
  const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.hooks.useReturnUrl(LOGIN),
    redirectToReturnUrl = _svs$ticket_partner$s.redirectToReturnUrl,
    redirectToKeepReturnUrl = _svs$ticket_partner$s.redirectToKeepReturnUrl;
  useEffect(() => {
    if (!hasRetailerCorpRole && !hasOneTimePassword) {
      redirectToKeepReturnUrl(LOGIN);
    }
  }, [hasRetailerCorpRole, hasOneTimePassword, redirectToKeepReturnUrl]);
  const onCancel = () => {
    redirectToReturnUrl();
  };
  const onPasswordChanged = () => {
    setOneTimePasswordUpdated();
    redirectToReturnUrl();
  };
  return React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 4
    },
    md: {
      col: 4
    },
    sm: {
      col: 12
    },
    xl: {
      col: 4
    },
    xs: 12
  }, React.createElement("h1", {
    className: "f-bold"
  }, HEADER), hasOneTimePassword ? React.createElement("span", null, INFO_ONE_TIME_PASSWORD) : null, React.createElement(ChangePasswordForm, {
    onCancel: onCancel,
    onPasswordChanged: onPasswordChanged
  }))));
};
svs.ticket_partner.changePassword.ChangePassword = ChangePassword;

 })(window);